import type { VoidFunctionComponent } from 'react';
import classNames from 'classnames';

type Props = {
  complete: boolean;
};

const CheckmarkCircleLoader: VoidFunctionComponent<Props> = ({ complete }) => (
  <div className={classNames({ 'circle-loader': true, 'circle-loader-complete': complete })}>
    <div className={classNames('circle-loader-checkmark draw', {
      'display-none': !complete,
    })} />
  </div>
);

export default CheckmarkCircleLoader;
